import { createApp, h } from 'vue'
import { createInertiaApp } from '@inertiajs/vue3';
import './../sass/app.scss';
import { ZiggyVue } from '../../vendor/tightenco/ziggy';
import PrimeVue from 'primevue/config';
import Aura from '@primeuix/themes/aura';
import vClickOutside from "click-outside-vue3"
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { PromiseDialog as VuejsDialog } from './libs/vue-dialog';
import './libs/vue-dialog/styles/main.scss';
import events from './helpers/events.js';
import './helpers/validate.js';
import * as Sentry from '@sentry/vue';
import { createManager } from '@vue-youtube/core';
import moment from 'moment';
import http from './plugins/http.js';

const appName =
  window.document.getElementsByTagName('title')[0]?.innerText || 'Console';

createInertiaApp({
  title: (title) => `${title} - ${appName}`,
  resolve: (name) =>
    resolvePageComponent(
      `./Pages/${name}.vue`,
      import.meta.glob('./Pages/**/*.vue')
    ),
  // resolve: (name) => {
  //   const pages = import.meta.glob('./Pages/**/*.vue', { eager: true });
  //   return pages[`./Pages/${name}.vue`];
  // },
  setup({ el, App, props, plugin }) {

    const app = createApp({ render: () => h(App, props) })
      .use(plugin)
      .use(ZiggyVue)
      .use(VuejsDialog)
      .use(vClickOutside)
      // Only fetch the YouTube player script once a video is actually shown
      .use(createManager({ deferLoading: { enabled: true, autoLoad: true } }))
      .use(PrimeVue, {
        theme: {
          preset: Aura
        }
      });

    app.config.globalProperties.$events = events;
    app.config.globalProperties.$http = http;
    app.config.globalProperties.$moment = moment;
    app.config.globalProperties.$storage = window.storage
    app.config.globalProperties.$route = route

    Sentry.init({
      app,
      environment: window?.storage?.environment,
      dsn: window?.storage?.sentry_dsn,
      // Setting this option to true will send default PII data to Sentry.
      // For example, automatic IP address collection on events
      sendDefaultPii: true
    });

    app.mount(el)

  },
  progress: {
    color: '#4B5563'
  }
});
